const Skip = () => {
  return (
    <svg
      width={19}
      height={20}
      id="skip"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M16.2175 3.28246C14.4232 1.4882 12.0375 0.5 9.5 0.5C6.96246 0.5 4.57681 1.4882 2.78246 3.28246C0.988196 5.07681 0 7.46246 0 10C0 12.5375 0.988196 14.9232 2.78246 16.7175C4.57681 18.5118 6.96246 19.5 9.5 19.5C12.0375 19.5 14.4232 18.5118 16.2175 16.7175C18.0118 14.9232 19 12.5375 19 10C19 7.46246 18.0118 5.07681 16.2175 3.28246ZM9.5 18.3247C4.90972 18.3247 1.17526 14.5903 1.17526 10C1.17526 5.40972 4.90972 1.67526 9.5 1.67526C14.0903 1.67526 17.8247 5.40972 17.8247 10C17.8247 14.5903 14.0903 18.3247 9.5 18.3247Z"
          fill="#764462"
        />
        <path
          d="M12.4106 9.07863L7.62508 6.31458V8.15727L4.43472 6.31458V13.6854L7.62508 11.8427V13.6854L12.4106 10.9214V14.0155H14.5653V5.98453H12.4106V9.07863Z"
          fill="#764462"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width={19}
            height={19}
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export { Skip };
